module.exports = __webpack_public_path__ + "media/images/lb/594-8b9ad7fb81f221c0f28d1ce16ca548b2.svg";